import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=1b59eb21&scoped=true"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"
import style0 from "./DiscountForm.vue?vue&type=style&index=0&id=1b59eb21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59eb21",
  null
  
)

export default component.exports